/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Which phase the step belongs to: connect (the service app the connection authenticates with) or cross_app_access (the AI agent).
 */
export const Group = {
  Connect: "connect",
  CrossAppAccess: "cross_app_access",
} as const;
/**
 * Which phase the step belongs to: connect (the service app the connection authenticates with) or cross_app_access (the AI agent).
 */
export type Group = OpenEnum<typeof Group>;

/**
 * Stable step identifier.
 */
export const IdentityProviderConnectionChecklistItemKey = {
  AddOinApp: "add_oin_app",
  CreateApiServicesApp: "create_api_services_app",
  PublicKeyAuth: "public_key_auth",
  Dpop: "dpop",
  GrantScopes: "grant_scopes",
  AssignAdminRoles: "assign_admin_roles",
  SubmitClientId: "submit_client_id",
  RegisterAiAgent: "register_ai_agent",
  LinkAgentApp: "link_agent_app",
  ActivateAgentApp: "activate_agent_app",
  RecordAiAgent: "record_ai_agent",
  AddAgentPublicKey: "add_agent_public_key",
  FirstResourceConnection: "first_resource_connection",
} as const;
/**
 * Stable step identifier.
 */
export type IdentityProviderConnectionChecklistItemKey = OpenEnum<
  typeof IdentityProviderConnectionChecklistItemKey
>;

/**
 * One step the organization administrator completes in the identity provider's console. Ordered; keys are stable across responses.
 */
export type IdentityProviderConnectionChecklistItem = {
  /**
   * Whether the last verification observed this step done. Omitted for steps the server cannot observe; the administrator tracks those.
   */
  completed?: boolean | undefined;
  /**
   * What to do in the console, including any value copied from this connection.
   */
  description: string;
  /**
   * Supporting lines under the description: ordered sub-steps for the public-key step, otherwise notes or the values to enter. Empty when the description says it all.
   */
  details: Array<string>;
  /**
   * Which phase the step belongs to: connect (the service app the connection authenticates with) or cross_app_access (the AI agent).
   */
  group: Group;
  /**
   * Stable step identifier.
   */
  key: IdentityProviderConnectionChecklistItemKey;
  /**
   * Short step title.
   */
  title: string;
};

/** @internal */
export const Group$inboundSchema: z.ZodMiniType<Group, unknown> = openEnums
  .inboundSchema(Group);

/** @internal */
export const IdentityProviderConnectionChecklistItemKey$inboundSchema:
  z.ZodMiniType<IdentityProviderConnectionChecklistItemKey, unknown> = openEnums
    .inboundSchema(IdentityProviderConnectionChecklistItemKey);

/** @internal */
export const IdentityProviderConnectionChecklistItem$inboundSchema:
  z.ZodMiniType<IdentityProviderConnectionChecklistItem, unknown> = z.object({
    completed: z.optional(z.boolean()),
    description: z.string(),
    details: z.array(z.string()),
    group: Group$inboundSchema,
    key: IdentityProviderConnectionChecklistItemKey$inboundSchema,
    title: z.string(),
  });

export function identityProviderConnectionChecklistItemFromJSON(
  jsonString: string,
): SafeParseResult<
  IdentityProviderConnectionChecklistItem,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      IdentityProviderConnectionChecklistItem$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'IdentityProviderConnectionChecklistItem' from JSON`,
  );
}
